import {
  GetHabitatQuery,
  ListHabitatsQuery,
  UpdateHabitatMutation,
} from '@akin-home/amplify';
import { updateHabitatMutation } from '@akin-home/habitats/frontend';
import { InfiniteData, useMutation, useQueryClient } from 'react-query';
import { habitatQueryKeys } from '.';

type CachedHabitat = NonNullable<GetHabitatQuery['getHabitat']>;
type CachedHabitats = NonNullable<ListHabitatsQuery['listHabitats']>['items'];

export const useUpdateHabitat = () => {
  const client = useQueryClient();

  return useMutation(updateHabitatMutation, {
    onSuccess({ data }) {
      if (!data.updateHabitat) return;

      const item = data.updateHabitat;

      client.setQueriesData<CachedHabitats | undefined>(
        habitatQueryKeys.lists(),
        (habitats) =>
          habitats?.map((habitat) =>
            habitat?.id === item?.id ? item : habitat
          )
      );

      client.setQueryData<CachedHabitat | undefined>(
        habitatQueryKeys.detail(item.id),
        (habitat) => habitat && item
      );

      client.setQueriesData<InfiniteData<ListHabitatsQuery>>(
        habitatQueryKeys.all_pages(),
        setPagedQueries(item)
      );
    },
  });
};

const setPagedQueries =
  (input: UpdateHabitatMutation['updateHabitat']) =>
  (data?: InfiniteData<ListHabitatsQuery>) => ({
    ...data,
    pageParams: data?.pageParams as string[],
    pages: data
      ? data.pages.map((page) => ({
          ...page,
          listUsers: {
            ...page.listHabitats,
            items: page.listHabitats?.items.map((user) =>
              user && user.id === input?.id ? input : user
            ),
          },
        }))
      : [],
  });
